export default "__VITE_ASSET__CsufVCJt__"